import Application from './application.js';
import Case, { CaseStatus } from './case.js';
import { DateRange } from './filter.js';
import User from './user.js';

export enum WorkflowAction {
  // entity: admin
  ArchiveAdmin = 'ArchiveAdmin',
  // entity: case
  ChangeStatus = 'ChangeStatus',
  Expedite = 'Expedite',
  InviteCaseParticipant = 'InviteCaseParticipant',
  Reassign = 'Reassign',
  UndoExpedite = 'UndoExpedite',
  UnlinkCaseParticipant = 'UnlinkCaseParticipant',
  CaseComment = 'CaseComment',
  CaseDocument = 'CaseDocument',
  // entity: Fund
  CreateFund = 'CreateFund',
  RemoveFund = 'RemoveFund',
  UpdateFund = 'UpdateFund',
  // entity: fulfillment
  InitiatePayment = 'InitiatePayment',
  PaymentUpdate = 'PaymentUpdate',
  PaymentMailingAddressUpdate = 'PaymentMailingAddressUpdate',
  PaymentFailed = 'PaymentFailed',
  // entity: note
  PublishNote = 'PublishNote',
  // entity: program
  ProgramUpdate = 'ProgramUpdate',
  ProgramCreate = 'ProgramCreate',
  RemoveProgramFund = 'RemoveProgramFund',
  AddProgramFund = 'AddProgramFund',
  // entity: program_referral
  SendReferral = 'SendReferral',
  // entity: application
  Submission = 'Submission',
  RemoveApplicationDocument = 'RemoveApplicationDocument',
  // entity: case/application
  // Logged when an application's eligibility is evaluated (or re-evaluated)
  EligibilityEvaluated = 'EligibilityEvaluated',
  // entity: tag
  CreateTag = 'CreateTag',
  EditTag = 'EditTag',
  DeleteTag = 'DeleteTag',
  AppliedTag = 'AppliedTag',
  RemovedTag = 'RemovedTag',
  // entity: user
  LinkLegacyUser = 'LinkLegacyUser',
  UserCreate = 'UserCreate',
  UserUpdate = 'UserUpdate',
  UnsubscribeCommunicationChannel = 'UnsubscribeCommunicationChannel',
  // entity: application
  NewVersion = 'NewVersion',
  // entity: applicationAnswer
  FieldReview_NOTE_ONLY = 'FieldReview_NOTE_ONLY',
  FieldReview_NEEDS_RESUBMISSION = 'FieldReview_NEEDS_RESUBMISSION',
  FieldReview_MEETS_REQUIREMENTS = 'FieldReview_MEETS_REQUIREMENTS',
  FieldReview_DOES_NOT_MEET_REQUIREMENTS = 'FieldReview_DOES_NOT_MEET_REQUIREMENTS',
  FieldReview_NEEDS_FURTHER_REVIEW = 'FieldReview_NEEDS_FURTHER_REVIEW',
  // entity: IncidentMessage
  CreateIncidentMessage = 'CreateIncidentMessage',
  RemoveIncidentMessage = 'RemoveIncidentMessage',
  // entity: tag_automation
  CreateTagAutomation = 'CreateTagAutomation',
  UpdateTagAutomation = 'UpdateTagAutomation',
  DeleteTagAutomation = 'DeleteTagAutomation',
  AppliedAutomatedTag = 'AppliedAutomatedTag',
}

export type WorkflowEventEntityType =
  | 'admin'
  | 'case'
  | 'fund'
  | 'fulfillment'
  | 'note'
  | 'program'
  | 'program_referral'
  | 'tag'
  | 'user'
  | 'application'
  | 'incident_message'
  | 'tag_automation';
export interface WorkflowEvent {
  id: string;
  entityId: string;
  entityType: WorkflowEventEntityType;
  case?: Case;
  userId?: string;
  user?: User;
  action: WorkflowAction;
  previousValue?: string;
  newValue?: string;
  previousAssignee?: User;
  newAssignee?: User;
  details?: string;
  createdAt: Date;
  deactivatedAt?: Date;
  assigneeId?: string;
  bulkOperationId?: string;
  application?: Application;
}
export default WorkflowEvent;

export interface CreateWorkflowEventInput {
  entityId: string;
  entityType: WorkflowEventEntityType;
  action: WorkflowAction;
  previousValue?: string;
  newValue?: string;
  details?: string;
  assigneeId?: string;
}

export interface WorkflowSummaryFilter {
  partnerId: string;
  createdAt?: DateRange;
  programId?: string;
}

export interface WorkflowSummary {
  casesReviewed: number;
  casesCertified: number;
  casesDenied: number;
  casesApproved: number;
}

export interface WorkflowTransition {
  previousStatus: CaseStatus[];
  newStatus: CaseStatus;
}

export const SendToCertification: WorkflowTransition = {
  previousStatus: [CaseStatus.ReadyForReview, CaseStatus.InReview],
  newStatus: CaseStatus.PendingCertification,
};

export const SendToApproved: WorkflowTransition = {
  previousStatus: [CaseStatus.ReadyForReview, CaseStatus.InReview],
  newStatus: CaseStatus.Approved,
};

export const SendToFiscal: WorkflowTransition = {
  previousStatus: [CaseStatus.PendingCertification],
  newStatus: CaseStatus.FiscalReview,
};
